import type { JSX } from "react";

import { type Intent, intents } from "@expert/sales-tools";
import { Group, Radio, Stack, Text } from "@mantine/core";

import classes from "./styles.module.css";

interface CallReasonFormProps {
    intent?: Intent;
    setIntent: (intent: Intent) => void;
}

export function CallReasonForm({ intent, setIntent }: CallReasonFormProps): JSX.Element {
    return (
        <Stack w="100%">
            <Text size="sm">Call reason</Text>
            <Radio.Group mt="0" mb="sm" value={intent} onChange={(val) => setIntent(val as Intent)}>
                <Stack gap="xs">
                    {intents.map((intent) => (
                        <Radio.Card className={classes.radioCard} p="sm" radius="md" value={intent} key={intent}>
                            <Group wrap="nowrap" align="flex-start">
                                <Radio.Indicator />
                                <Text c="dark.0" size="xs">
                                    {intent}
                                </Text>
                            </Group>
                        </Radio.Card>
                    ))}
                </Stack>
            </Radio.Group>
        </Stack>
    );
}
